import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ElementOrIcon } from '../../../components/elementOrIcon/elementOrIcon';
import { Link } from '../../../components/link/link';
import { LinkActionType } from '../../../components/link/types/action';
import { Text } from '../../../components/text/text';
import { TextComponentType } from '../../../components/text/types/component';
import { useManageState } from '../../../hooks/useManageState/useManageState';
import { pickDataAttributes } from '../../../utils/pickDataAttributes/pickDataAttributes';
import { BreadcrumbLiStyled, IconContainerStyled, LinkContainerStyled, } from '../breadcrumbs.styled';
import { BreadcrumbsStateType } from '../types/state';
/**
 * @description
 * CrumbStandAlone component is a component that shows a crumb with a link.
 * @param {IBreadcrumbStandAlone} props
 * @returns {JSX.Element}
 * @example
 * <CrumbStandAlone />
 * <CrumbStandAlone variant="primary" />
 */
export const CrumbStandAlone = ({ crumb, styles, dataTestId, lastOneCrumbComponent = TextComponentType.SPAN, ...props }) => {
    const { state, setRef } = useManageState({
        states: Object.values(BreadcrumbsStateType),
        active: props.lastCrumb,
    });
    const dataAttributes = pickDataAttributes(props);
    return (_jsx(_Fragment, { children: _jsx(BreadcrumbLiStyled, { ref: setRef, "aria-current": props.lastCrumb ? 'page' : undefined, "data-testid": dataTestId, children: props.lastCrumb ? (_jsx(Text, { ...dataAttributes, component: lastOneCrumbComponent, customTypography: styles[state].lastOneCrumb, dataTestId: "last-breadcrumb", children: crumb.name })) : (_jsxs(_Fragment, { children: [props.link && (_jsx(LinkContainerStyled, { styles: styles, children: _jsx(Link, { ...dataAttributes, action: LinkActionType.NAVIGATION, "aria-label": crumb.ariaLabel, disabled: props.lastCrumb, url: crumb.url, ...props.link, dataTestId: "breadcrumb-link", onClick: event => crumb.onClick?.(crumb.url, event), children: crumb.name }) })), _jsx(IconContainerStyled, { state: state, styles: styles, children: _jsx(ElementOrIcon, { customIconStyles: styles[state].iconDivider, ...props.dividerIcon }) })] })) }) }));
};
//# sourceMappingURL=crumbStandAlone.js.map